import { EmptyState } from '@restomarker/ui-kit';
import { Link } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { startScreenFor } from '@/modules/auth';
import { t } from '@/shared/i18n';
import { useSession } from '@/shared/session';

import styles from './forbiddenPage.module.css';

/**
 * Отказ по роли.
 *
 * Показывается вместо молчаливого редиректа: менеджер должен понимать, что экран
 * существует и закрыт, иначе это выглядит как поломка приложения и превращается
 * в звонок в саппорт.
 *
 * Действие обязательно. Без него экран был тупиком: навигация не рисовалась (её
 * съедал ранний `return` в layout), кнопки не было, и уйти можно было только правкой
 * адреса. В оболочке на устройстве точки адресной строки нет вовсе — человек оставался
 * заперт до перезапуска приложения.
 */
export function ForbiddenPage(): ReactElement {
  const session = useSession();

  return (
    <main data-testid="forbidden" className={styles.page}>
      <EmptyState
        title={t('auth.forbidden.title')}
        description={t('auth.forbidden.description')}
        action={
          // Цель считается ПО РОЛИ: «главная» у владельца сети и у менеджера точки
          // разная, а отправить человека на экран, который ему тоже закрыт, значит
          // заменить один тупик другим.
          session.data ? (
            <Link to={startScreenFor(session.data)} className={styles.action}>
              {t('auth.forbidden.action')}
            </Link>
          ) : null
        }
      />
    </main>
  );
}
